<template>
  <modal :title='$t(Dtitle)' :visible.sync='isShowDialog' width='1000px'>
    <el-form v-loading='detaiilLoad' ref='form' label-width='180px' style='height: 650px' :model='dioForm'
             v-show='ismode'>
      <el-row :gutter='30'>
        <el-col :span='12'>
          <el-form-item :label="$t('user.name')" prop='username'>{{ editObj.username }}</el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item :label="$t('user.account')" prop='account'>
            {{ editObj.account }}
            <i class='el-icon-edit' @click="handleMode('edit')" style='float: right'></i>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter='30'>
        <el-col :span='12'>
          <el-form-item :label="$t('public.phone_num')" prop='mobile'>{{ editObj.mobile }}</el-form-item>
        </el-col>
        <el-col :span='12'>
          <el-form-item :label="$t('public.email')" prop='email'>{{ editObj.email }}</el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter='30'>
        <el-col :span='12'>
          <el-form-item :label="$t('user.status')" prop='status'>
            {{ editObj.status === 1 ? $t('public.user_status_activity') : $t('public.user_status_cancel') }}
          </el-form-item>
        </el-col>
        <!--<el-col :span='12'>-->
        <!--  <el-form-item :label="$t('user.gender')" prop='gender'>-->
        <!--    {{ editObj.gender === 1 ? $t('user.gender_1') : $t('user.gender_0') }}-->
        <!--  </el-form-item>-->
        <!--</el-col>-->
      </el-row>

      <el-form-item :label="$t('user.type')" prop='roleType'>{{ changeRoleType(editObj.roleType) }}</el-form-item>

      <el-form-item :label="$t('public.table_scope')" prop='customerId' v-if='isProxyType'>{{ editObj.customerName }}
      </el-form-item>

      <!-- 角色 -->
      <el-row>
        <el-col :span='12'>
          <el-form-item :label="$t('user.role')" prop='roleId' :style="{ color: editObj.roleStatus == 0 ? 'red' : '' }">
            {{ editObj.roleName }}
          </el-form-item>
        </el-col>
        <el-col :span='12' v-if='!isProxyType'>
          <el-form-item :label="$t('user.governing_customers')" prop='customerId'>
            <el-select v-model='editObj.customerId' style='width:250px;margin-right:15px' @change='proxyFn'>
              <el-option v-for='item in editObj.customers' :key='item.id' :value='item.id'
                         :label='$t(item.name)'></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('user.associated_architecture')" prop='sceneIds'>
        <div class='treeClass'>
          <el-tree :props='props' :data='editStructureArray' ref='tree'></el-tree>
        </div>
      </el-form-item>
    </el-form>
    <PublicContent
      v-show='!ismode'
      :customerArrayDetail='customerArrayDetail'
      :editStructureArray='editStructureArray'
      :loadingeditTree='loadingTree'
      :roleArrayEdit='roleArray'
      :editObj='editObj'
      ref='PublicContent'
      @goBack='handleMode'
      v-bind='$attrs'
    />
    <div slot='footer'>
      <el-button type='primary' @click='isShowDialog = false'>
        {{ $t('public.btn_close') }}
      </el-button>
      <el-button type='primary' v-if='!ismode' @click='handleSave'>
        {{ $t('public.btn_apply') }}
      </el-button>
    </div>
  </modal>
</template>

<script>
import { accountEdit, accountStructure } from '@/api/modules/userInfo.js'
import PublicContent from './Public.vue'

export default {
  props: ['title', 'isShowDetail', 'detailObj', 'customerArrayDetail', 'StructureArray', 'detaiilLoad', 'roleArray'],
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShowDetail
      },
      set: function (val) {
        this.$emit('update:isShowDetail', val) // 可以优化成model  或者minx
      }
    }
  },
  watch: {
    detailObj (newVal) {
      this.editObj = { ...newVal }
      if (newVal.roleType === -1) {
        this.isProxyType = false
      } else {
        this.isProxyType = true
      }

      if (newVal.roleType === 2 || newVal.roleType === 3) {
        this.isPingTaiAdmin = false
      } else {
        this.isPingTaiAdmin = true
      }
    },
    title (newVal) {
      this.Dtitle = newVal
    },
    StructureArray (newVal) {
      this.editStructureArray = [...newVal]
    }
  },
  components: {
    PublicContent
  },
  data () {
    return {
      Dtitle: this.$t('user.account_info'),
      dioForm: {},
      // 编辑还是详情
      ismode: true,
      isPingTaiAdmin: true,
      // 是否代理类型
      isProxyType: true,
      ChildrenStructureArray: [],
      props: {
        label: 'label',
        children: 'item'
      },
      // 管辖客户
      proxySenceId: '',
      // 编辑框数据
      editObj: {},
      editStructureArray: [],
      loadingTree: false
    }
  },
  methods: {
    changeRoleType (id) {
      let str = ''
      for (const item of this.$attrs.roleTypeArray) {
        if (item.value === id) {
          str = item.label
          break
        }
      }
      return this.$t(str)
      // return id
    },
    changeFn (id) {
      let str = ''
      for (const item of this.customerArrayDetail) {
        if (item.id === id) {
          str = item.name
          break
        }
      }
      return str
    },
    handleMode (str) {
      this.ismode = !this.ismode
      if (str === 'edit') {
        this.Dtitle = this.$t('user.edit_account')

        this.getEditTree()
      } else {
        this.Dtitle = this.$t('user.account_info')
      }
      this.editObj = { ...this.detailObj }
    },
    getEditTree (scope, isEdit) {
      const {
        roleType,
        scopeId,
        id,
        customerId
      } = this.editObj
      console.log(roleType)
      let param = ''
      if (roleType === -1) {
        param = 'scope'
      } else {
        param = 'customerId'
      }
      const query = {
        type: roleType,
        [param]: customerId,
        scope: scope || scopeId,
        isEdit: isEdit || 1,
        id: id
      }
      this.loadingTree = true
      accountStructure(query)
        .then(({ result }) => {
          this.editStructureArray = result.item
        })
        .finally(() => {
          this.loadingTree = false
        })
    },
    proxyFn (id) {
      let scopeId = ''
      this.detailObj.customers.forEach(item => {
        if (id === item.id) {
          scopeId = item.scopeId
        }
      })
      this.getEditTree(scopeId)
    },
    treeCheck (rule, value, callback) {
      if (this.dioForm.sceneIds.length === 0) {
        callback(this.$t('validate.user_archit_required'))
      } else {
        callback()
      }
    },
    async handleSave () {
      const publicChilren = this.$refs.PublicContent
      const HalfCheckedNode = publicChilren.$refs.tree.getHalfCheckedNodes()
      const CheckedNodes = publicChilren.$refs.tree.getCheckedNodes()
      // console.log('半选==>', HalfCheckedNode);
      // console.log('全选==>', CheckedNodes);
      const senceArray = HalfCheckedNode.map(item => item.scopeId)
      const jiagouArray = CheckedNodes.map(item => item.sceneId || item.scopeId)

      publicChilren.dioForm.sceneIds = [...senceArray, ...jiagouArray]
      const falg = await publicChilren.justify()
      if (!falg) return
      // return
      accountEdit(publicChilren.dioForm).then(({
        result,
        state
      }) => {
        if (result === 200) {
          this.isShowDialog = false
          this.$message.success(this.$t('user.user_edit_code_200'))
          this.$parent.getListFn()
        } else if (result === 201) {
          this.isShowDialog = false
          this.$message.success(this.$t('user.user_edit_code_201'))
          this.$parent.getListFn()
        } else if (result === 412) {
          this.$message.error(this.$t('user.user_edit_code_412'))
        } else if (result === 416) {
          this.$message.error(this.$t('user.user_edit_code_416'))
        } else if (result === 417) {
          this.$message.error(this.$t('user.user_edit_code_417'))
        } else if (result === 418) {
          this.$message.error(this.$t('user.user_edit_code_418'))
        } else if (result === 419) {
          this.$message.error(this.$t('user.user_edit_code_419'))
        } else if (result === 501) {
          this.$message.success(this.$t('user.user_edit_code_501'))
          this.isShowDialog = false
          this.$parent.getListFn()
        } else {
          this.$message.error(state.msg)
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.treeClass {
  height: 300px;
  overflow: auto;
  border: 1px solid #e7e7e7;
  padding: 10px 0;
  box-sizing: border-box;
}
</style>
